import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BlockingOverlay } from './shared/components/blocking-overlay/blocking-overlay';
import { LoadingBar } from './shared/components/loading-bar/loading-bar';
import { ToastHost } from './shared/components/toast-host/toast-host';
import { CookieConsent } from './shared/components/cookie-consent/cookie-consent';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingBar, BlockingOverlay, ToastHost, CookieConsent],
  // The bar, the wait overlay and the toast stack live above the outlet so they survive every
  // route change — all three are driven by in-flight HTTP, not by navigation, and must not be
  // torn down mid-request. The toast stack especially: a failed save has to outlive the
  // navigation it may have triggered.
  template: '<app-loading-bar /><app-blocking-overlay /><app-toast-host /><router-outlet /><app-cookie-consent />',
  styles: ':host { display: block; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
